import React, { Component } from 'react';
import _ from 'underscore';
import ga from 'analytics';

import Utils from 'utils/Utils.js';
import SurveyPageInputNumber from './SurveyPageInputNumber.js';


class SurveyPageInputNumberContainer extends Component {
    constructor(props) {
        super(props);
        this.initialState = {value:'',valid:false};
        this.state = this.props.savedState || this.initialState;
        if(!this.props.savedState) {
            this.state = this.applyPersistedState();
        }
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    componentWillMount() {
        ga('send', 'pageview', { 'page': '/virtual/survey-page-input-number' }); 
    }
    applyPersistedState() {
        var userChallenge = Utils.deref(this.props.surveyPage, 'challenge.userChallenge', null);
        if(userChallenge && _.isFinite(userChallenge.value)) {
            var value = userChallenge.value;
            var state = {value:value, valid:this.isValid(value)};
            return state;
        }
        return this.state;
    }
    onChange(event) {
        var value = event.currentTarget.value;
        var valid = this.isValid(value);
        this.setState({value:value,valid:valid});
    }
    onSubmit(event) {
        if(this.state.valid) {
            var value = Math.round(Number(this.state.value));
            this.props.onSubmit(event,{challengeId:this.props.surveyPage.challenge.id, value:value}, this.state);
        } else {
            event.preventDefault();
        }
    }
    isValid(value) {
        return _.isFinite(Number(value));
    }
    render() {
        return <SurveyPageInputNumber
                   surveyPage={this.props.surveyPage}
                   inlineButtons={this.props.inlineButtons}
                   pageNum={this.props.pageNum}
                   numPages={this.props.numPages}
                   onSkip={this.props.onSkip}
                   value={this.state.value}
                   onSubmit={this.onSubmit}
                   onChange={this.onChange}
                   valid={this.state.valid}
                   />;
    }

}

export default SurveyPageInputNumberContainer;



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageInputNumberContainer.js